import { changeAppState, useAppState } from "../../../../common/appState";
import { useDelayedState } from "../../../../common/hooks/useDelayedState";
import ShurikenProgress from "../../Animations/ShurikenProgress";
import { CenterDialog } from "../CenterDialog";
import { SimpleDialogContent } from "./DialogContent";

const transitionMilliseconds = 300;

export default function SimpleDialog() {
    const [addCoinsDialogState] = useAppState("simpleDialogState");
    const { delayedState } = useDelayedState(
        addCoinsDialogState,
        state => state.open,
        transitionMilliseconds
    );

    return (
        <CenterDialog
            open={addCoinsDialogState.open}
            onClose={() => {
                changeAppState("simpleDialogState", { open: false });
            }}
            transitionMilliseconds={transitionMilliseconds}
            style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
            }}
            globalDialogState={addCoinsDialogState}
        >
            {delayedState.open ? (
                <SimpleDialogContent state={delayedState} />
            ) : (
                <ShurikenProgress size={50} style={{ marginTop: 115 }} />
            )}
        </CenterDialog>
    );
}
